type BadgeVariant = 'neutral' | 'red';

export type TeamRole = 'admin' | 'member';

export const ROLE_OPTIONS = [
  { value: 'member', label: 'Miembro' },
  { value: 'admin', label: 'Admin' },
];

const ROLE_LABELS: Record<TeamRole, string> = {
  admin: 'Admin',
  member: 'Miembro',
};

const ROLE_VARIANTS: Record<TeamRole, BadgeVariant> = {
  admin: 'red',
  member: 'neutral',
};

export function roleLabel(role: TeamRole): string {
  return ROLE_LABELS[role];
}

export function roleVariant(role: TeamRole): BadgeVariant {
  return ROLE_VARIANTS[role];
}
